import $ from 'jquery';
import SubscriptionService from '../_shared/subscription-service';
import AccountService from '../_shared/account-service';
import ProductEvents from '../gtm/product-events';

export default class PremiumVideo {
  constructor(premiumContentSelector, premiumPlayerId, subscribeButtonSelector) {
    this.$premiumContent = $(premiumContentSelector);
    this.premiumPlayerId = premiumPlayerId;
    this.videoId = this.$premiumContent.data('video-id');
    this.pageId = this.$premiumContent.data('page-id');
    this.lang = this.$premiumContent.data('lang');
    this.$proceedToSubscriebBtn = $(subscribeButtonSelector);

    this.gtmProductEvents = new ProductEvents('ott', '9c1b4533-9165-4c4a-a8e9-85a4bd70b8e1');

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$premiumContent.length) {
      this.isInitialized = false;

      return;
    }

    this.gtmProductEvents.promoImpressionEvent(this.$proceedToSubscriebBtn[0]);

    this.$proceedToSubscriebBtn.on('click', (e) => {
      e.preventDefault();
      this.gtmProductEvents.promoClickEvent(e.currentTarget);
    });

    const isAuthenticated = await AccountService.isAuthenticated();

    if (!isAuthenticated) {
      this.$premiumContent.addClass('not-eligible');

      return;
    }

    const { videoReference } = await SubscriptionService.fetchVideoDetails(this.videoId, this.pageId, this.lang) || {};

    if (!videoReference) {
      this.$premiumContent.addClass('not-eligible');
      this.$proceedToSubscriebBtn
        .attr('href', this.$proceedToSubscriebBtn.data('subscription-href'));

      return;
    }

    this.initPlayer(videoReference);
  }

  initPlayer(videoId) {
    const { $premiumContent } = this;

    try {
      window.videojs.getPlayer(this.premiumPlayerId).ready(function onPlayerReady() {
        const player = this;

        player.catalog.getVideo(videoId, (error, video) => {
          if (error) {
            console.error('An error occured white getting video: ', error);
            return;
          }

          player.catalog.load(video);
          $premiumContent.addClass('is-eligible');
        });
      });
    } catch (e) {
      console.error('Error:', e.error, 'Details:', e.details);
    }
  }
}
